module.exports = __webpack_public_path__ + "static/media/RNSSanz-SemiBold.f4abe346.ttf";